import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/modal-view/thunks/hide-modal-view.ts
var hideModalView = createAsyncThunk(thunkTypes.HIDE_MODAL_VIEW, async (param, { dispatch }) => {
	if (param?.id) {
		const modalView = {
			id: param?.id,
			isVisible: false
		};
		dispatch(actions.updateModalView(modalView));
		setTimeout(() => {
			dispatch(actions.disposeModalView(modalView.id));
		}, 400);
		return modalView;
	}
});
//#endregion
export { hideModalView };

//# sourceMappingURL=hide-modal-view.js.map